import http from '@/utils/http';
export const getMainUserBindList = async () => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/getMainUserBindList');
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const getSelfUserBindList = async () => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/getSelfUserBindList');
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const searchUsers = async (params) => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/searchUsers', params);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const applyBind = async (params) => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/applyBind', params);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const operateUserBind = async (params) => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/operateUserBind', params);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const dissolveTeam = async () => {
  const { rsp, err }: any = await http.post('/hospital/userGroup/dissolveTeam');
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const changePasswd = async (params) => {
  const { rsp, err }: any = await http.post('/hospital/changePasswd', params);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};
